import { formatData, sortByDateReverse } from "./utils";

export function fetchOrders(){
    return async function (dispatch){
        dispatch({ type: "FETCH_ORDERS_START", payload: "" })
        try {

            const req = await fetch('/orders/all', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content,
                },
                credentials: 'same-origin',
            });
            let res = await req.json();
            console.log('fetchOrders res : ', res);

            if (!res.error) {
                let formated_orders_list = formatData(res, "order_id")
                dispatch({
                    type: "GET_ORDERS",
                    payload: formated_orders_list
                })
 
                dispatch({ type: "FETCH_ORDERS_FULFILLED", payload: "" }) 
            } else {
                dispatch({ type: "FETCH_ORDERS_ERROR", payload: res.error })
            }

        } catch (error) {
            console.log("[ERROR] get orders list : ", error);
            dispatch({ type: "FETCH_ORDERS_ERROR", payload: error })
        }
         
    }
}
export function validateOrder(data){
    return async function (dispatch){
        dispatch({ type: "VALIDATE_ORDER_START", payload: "" })
        try {

            const req = await fetch('/orders/validate', {
                method: 'POST',
                body: JSON.stringify(data),
                headers: {
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content,
                },
                credentials: 'same-origin',
            });
            let res = await req.json();
            console.log('fetchOrders res : ', res);

            if (!res.error) {
                console.log('====================================');
                console.log("OK");
                console.log('====================================');
                // dispatch({ type: "UPDATE_ORDER", payload: "" }) 
 
                dispatch({ type: "VALIDATE_ORDER_FULFILLED", payload: "" }) 
            } else {
                dispatch({ type: "VALIDATE_ORDER_ERROR", payload: res.error })
            }

        } catch (error) {
            console.log("[ERROR] validate order: ", error);
            dispatch({ type: "VALIDATE_ORDER_ERROR", payload: error })
        }
         
    }
}
export function updateOrder(data){
    return async function (dispatch){
        dispatch({ type: "UPDATE_ORDER_START", payload: "" })
        try {

            const req = await fetch('/orders/update', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content,
                },
                body: JSON.stringify(data),
                credentials: 'same-origin',
            });
            let res = await req.json();
            console.log('updateOrder res : ', res);

            if (!res.error) {
                
                dispatch({
                    type: "UPDATE_ORDER",
                    payload: data
                })
    
               
                dispatch({ type: "UPDATE_ORDER_FULFILLED", payload: "" }) 
            } else {
                dispatch({ type: "UPDATE_ORDER_ERROR", payload: res.error })
            }

        } catch (error) {
            console.log("[ERROR] get orders list : ", error);
            dispatch({ type: "UPDATE_ORDER_ERROR", payload: error })
        }
         
    }
}
